import { getChatShortLink } from "@/services/chat.service"
import { isLogined } from "@/services/mallUser.service"
import { useEffect, useMemo, useState } from "react"
import { useAnonymousUserStore, useUserStore } from '@/store/userStore';
import { useParams, useRevalidator } from "react-router-dom";
import config from "@/config/config";

export default function ChatTestIframe({ targetId, setOpen }: { targetId?: string, setOpen: Function }) {
    const { productId = '' } = useParams()
    const revalidate = useRevalidator()
    const { path = '' } = useParams() as any
    const targetProductId = !!targetId ? targetId : productId
    const userId = useUserStore.getState().mallUserId
    const anonymousId = useAnonymousUserStore.getState().mallUserId
    const [shortLink, setShortLink] = useState('')
    async function iframeLoginFunc(event: MessageEvent<any>) {
        if (event.data === 'login') {
            console.log('login')
            revalidate.revalidate()
        }
    }
    async function iframeLogOutFunc(event: MessageEvent<any>) {
        if (event.data === 'logout') {
            console.log('logout')
            setOpen(false)
            const checkPage = window.location.href.includes('order-n-shipping-info')
                || window.location.href.includes('order-detail-info')
                || window.location.href.includes('pay-result')
            if (!!checkPage) {
                window.location.href = `${config.api.flowing_spacehome_url}/mall/${path}`
            } else {
                revalidate.revalidate()
            }
        }
    }
    useEffect(() => {
        (async () => {
            await getChatShortLink(isLogined() ? userId : anonymousId, targetProductId).then(r => {
                setShortLink(`${config.url.chatting_url}/qna/${r.data?.shortLink || ''}`)
                return r
            }).catch(() => { setShortLink(`${config.url.chatting_url}/qna/`) })
        })()
    }, [isLogined(), targetProductId])
    useEffect(() => {
        if (isLogined()) return;
        window.addEventListener('message', iframeLoginFunc)
        return () => {
            console.log('%c iframe is unmounted', 'color:red;font-weight:bold;')
            window.removeEventListener('message', iframeLoginFunc)
        }
    }, [isLogined()])
    useEffect(() => {
        if (!isLogined()) return;
        window.addEventListener('message', iframeLogOutFunc)
        return () => {
            console.log('%c iframe is unmounted', 'color:red;font-weight:bold;')
            window.removeEventListener('message', iframeLogOutFunc)
        }
    }, [isLogined()])
    const memoLink = useMemo(() => {
        return shortLink
    }, [shortLink])
    return (
        <iframe style={{
            width: '100%',
            height: '100%',
            border: 'none'
        }} src={`${memoLink}`} />
    )
}